// import { useEffect, useMemo, useState } from "react";

// import { useAccount } from './account-context';
// import { getApiPaths } from "./constants/healthEndpoints";
// import useApi from "./useApi";

// const compareStoreId = (a, b) => {
//   const an = parseInt(a?.id ?? "", 10);
//   const bn = parseInt(b?.id ?? "", 10);
//   if (!Number.isNaN(an) && !Number.isNaN(bn)) return an - bn;
//   return String(a?.id ?? "").localeCompare(String(b?.id ?? ""), "en", {
//     numeric: true,
//     sensitivity: "base",
//   });
// };

// const useStoreStatusLogic = ({
//   stores,
//   setStores,
//   filter,
//   setFilter,
//   currentPage,
//   setCurrentPage,
//   source,
//   selectedService,
// }) => {
//   const [selectedStore, setSelectedStore] = useState([]);
//   const [pageSize, setPageSize] = useState(100);
//   const [counts, setCounts] = useState({
//     all: 0,
//     healthy: 0,
//     unhealthy: 0,
//     amber: 0,
//   });
// const { accountId } = useAccount();
//   const API_URL_PATHS = getApiPaths(accountId);
// const { STORES_VIEW } = API_URL_PATHS;
//   const { data, loading, error } = useApi(STORES_VIEW);

// //  // Transform incoming API data into canonical store objects
// //   useEffect(() => {
// //     if (!Array.isArray(data) || typeof setStores !== "function") return;

// //     const transformed = data.map((item) => ({
// //       id: item?.store ?? item?.id ?? "",
// //       status: item?.status ?? null,
// //       color:
// //         item?.color === "amber" || item?.color === "#FFC107"
// //           ? "#FFC107"
// //           : item?.color ?? "green",
// //       issue: item?.issue ?? "",
// //     }));

// //     setStores(transformed);
// //   }, [data, setStores]);
// // console.log('useStoreStatusLogic - raw API data', selectedService?.key);

// // console.log('useStoreStatusLogic - raw API data', selectedService);
// console.log('useStoreStatusLogic - raw API data', data);
// useEffect(() => {
//   if (!Array.isArray(data) || typeof setStores !== "function") return;

//   // FIX: use key from selectedService first, 
//   const activeService = selectedService?.key || "";

//   const serviceKeys = ["DigitalOrdering", "Sesame", "eProd", "MyStore"];

//   const transformed = data.map(item => {
//     // Case 1: Selected service exists in this store → return only that service
//     if (activeService && item[activeService]) {
//       const svc = item[activeService];

//       return {
//         id: item?.store ?? item?.id ?? "",
//         status: svc.status || "",
//         color:
//           svc.color === "amber" || svc.color === "#FFC107"
//             ? "#FFC107"
//             : svc.color || "green",
//         issue: activeService || "",
//       };
//     }

//     // Case 2: Selected service NOT found → return all bad services
//     let badServices = [];

//     serviceKeys.forEach(key => {
//       const svc = item[key];
//       if (svc && (svc.status === "down" || svc.status === "degraded")) {
//         badServices.push(key);
//       }
//     });

//     return {
//       id: item?.store ?? item?.id ?? "",
//       status: item?.status || "",
//       color:
//         item?.color === "amber" || item?.color === "#FFC107"
//           ? "#FFC107"
//           : item?.color || "green",
//       issue: badServices.join(",") || "",
//     };
//   });

//   setStores(transformed);
// //   console.log('useStoreStatusLogic - raw API data', data);
// // console.log('useStoreStatusLogic - selectedService', selectedService);
// // console.log('useStoreStatusLogic - stringified API data', JSON.stringify(transformed));
// }, [data, selectedService, setStores]);
//   // console.log('useStoreStatusLogic - API data', data);
//   // console.log('useStoreStatusLogic - transformed stores', stores);

//   // Compute counts based on current stores and source/context
//   useEffect(() => {
//     if (!Array.isArray(stores) || stores.length === 0) {
//       setCounts({ all: 0, healthy: 0, unhealthy: 0, amber: 0 });
//       return;
//     }

//     let unhealthy = [];
//     let amber = [];
//     let healthy = [];

//     if (source === "services" && selectedService) {
//       unhealthy = stores.filter(
//         (s) =>
//           s.issue === selectedService?.key &&
//           (s.color === "red" || s.color === "#FFC107" || s.color === "amber")
//       );

//       amber = stores.filter(
//         (s) =>
//           s.issue === selectedService?.key &&
//           (s.color === "#FFC107" || s.color === "amber")
//       );

//       healthy = stores.filter((s) => s.color === "green");
//     } else {
//       unhealthy = stores.filter((s) => s.color === "red" || s.color === "#FFC107");
//       amber = stores.filter((s) => s.color === "#FFC107" || s.color === "amber");
//       healthy = stores.filter((s) => s.color === "green");
//     }

//     setCounts({
//       all: unhealthy.length + healthy.length,
//       healthy: healthy.length,
//       unhealthy: unhealthy.length,
//       amber: amber.length,
//     });
//   }, [stores, source, selectedService]);
// //console.log('useStoreStatusLogic - counts', counts);
//   const sortedStores = useMemo(
//     () => (Array.isArray(stores) ? stores.slice().sort(compareStoreId) : []),
//     [stores]
//   );

//   const filteredStores = useMemo(() => {
//     const base = sortedStores;

//     return base.filter((store) => {
//       if (source === "services" && selectedService) {
//         if (filter === "Unhealthy") {
//           return (
//             store.issue === selectedService?.key &&
//             (store.color === "red" || store.color === "#FFC107")
//           );
//         }
//         if (filter === "Amber") {
//           return (
//             store.issue === selectedService?.key && store.color === "#FFC107"
//           );
//         }
//         if (filter === "Healthy") {
//           return store.color === "green";
//         }
//       } else {
//         // Default filtering for Stores page
//         if (Array.isArray(selectedStore) && selectedStore.length > 0) {
//           const selectedIds = new Set(selectedStore.map((s) => s.value));
//           return selectedIds.has(store.id);
//         }
//         if (filter === "Healthy") return store.color === "green";
//         if (filter === "Unhealthy")
//           return store.color === "red" || store.color === "#FFC107";
//         if (filter === "Amber") return store.color === "#FFC107";
//       }
//       return true;
//     });
//   }, [sortedStores, selectedStore, filter, source, selectedService]);

//   useEffect(() => {
//     const totalPagesNow = Math.max(1, Math.ceil(filteredStores.length / pageSize));
//     if (typeof setCurrentPage === "function" && currentPage > totalPagesNow) {
//       setCurrentPage(totalPagesNow);
//     }
//   }, [filteredStores.length, pageSize, currentPage, setCurrentPage]);

//   const indexOfLastItem = currentPage * pageSize;
//   const indexOfFirstItem = Math.max(0, indexOfLastItem - pageSize);
//   const currentStores = filteredStores.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.max(1, Math.ceil(filteredStores.length / pageSize));

//   const storeOptions = useMemo(
//     () =>
//       sortedStores.map((s) => ({
//         value: s.id,
//         label: String(s.id ?? ""),
//       })),
//     [sortedStores]
//   );

//   const visibleStart = filteredStores.length === 0 ? 0 : indexOfFirstItem + 1;
//   const visibleEnd = Math.min(indexOfLastItem, filteredStores.length);

//   return {
//     loading,
//     error,
//     selectedStore,
//     setSelectedStore,
//     pageSize,
//     setPageSize,
//     counts,
//     storeOptions,
//     filteredStores,
//     currentStores,
//     totalPages,
//     visibleStart,
//     visibleEnd,
//   };
// };

// export default useStoreStatusLogic;


import { useEffect, useMemo, useState } from "react";

import { useAccount } from "./account-context";
import { getApiPaths } from "./constants/healthEndpoints";
import useApi from "./useApi";

/* -----------------------------
   Utility: Compare store IDs
------------------------------ */
const compareStoreId = (a, b) => {
  const an = parseInt(a?.id ?? "", 10);
  const bn = parseInt(b?.id ?? "", 10);
  if (!Number.isNaN(an) && !Number.isNaN(bn)) return an - bn;
  return String(a?.id ?? "").localeCompare(String(b?.id ?? ""), "en", {
    numeric: true,
    sensitivity: "base",
  });
};

/* =============================
   MAIN HOOK
============================= */
const useStoreStatusLogic = ({
  stores,
  setStores,
  filter,
  setFilter,
  currentPage,
  setCurrentPage,
  source,
  selectedService,
}) => {
  const [selectedStore, setSelectedStore] = useState([]);
  const [pageSize, setPageSize] = useState(100);
  const [counts, setCounts] = useState({
    all: 0,
    healthy: 0,
    unhealthy: 0,
    amber: 0,
  });

  const { accountId } = useAccount();
  const API_URL_PATHS = getApiPaths(accountId);
  const { STORES_VIEW } = API_URL_PATHS;

  const { data, loading, error } = useApi(STORES_VIEW);

  /* ======================================================
     TRANSFORM NEW STORES API → UI-COMPATIBLE STRUCTURE
  ======================================================= */
  useEffect(() => {
    if (!Array.isArray(data) || typeof setStores !== "function") return;

    const activeService = selectedService?.key || "";

    const transformed = data.map((item) => {
      const services = item.services || {};
      const serviceNames = Object.keys(services);

      // Services that actually have alerts
      const unhealthyServices = serviceNames.filter(
        (svc) => Array.isArray(services[svc]) && services[svc].length > 0
      );

      /* ------------------------------
         SERVICES PAGE (service view)
      ------------------------------- */
      if (activeService) {
        const hasAlerts = services[activeService]?.length > 0;

        return {
          id: item.store,
          status: hasAlerts ? "down" : "up",
          color: hasAlerts ? "red" : "green",
          issue:  activeService,
          alerts: services[activeService] || [],
        };
      }

      /* ------------------------------
         STORES PAGE
      ------------------------------- */
      if (unhealthyServices.length > 0) {
        return {
          id: item.store,
          status: "down",
          color: "red",
          issue: unhealthyServices.join(","),
          alerts: unhealthyServices.flatMap((svc) => services[svc]),
        };
      }

      /* ------------------------------
         HEALTHY STORE
      ------------------------------- */
      return {
        id: item.store,
        status: "up",
        color: "green",
        issue: "",
        alerts: [],
      };
    });

    setStores(transformed);
  }, [data, selectedService, setStores]);

  /* ======================================================
     COUNTS (Healthy / Unhealthy / Amber)
  ======================================================= */
  useEffect(() => {
    if (!Array.isArray(stores) || stores.length === 0) {
      setCounts({ all: 0, healthy: 0, unhealthy: 0, amber: 0 });
      return;
    }

    let unhealthy = [];
    let amber = [];
    let healthy = [];

    if (source === "services" && selectedService) {
      unhealthy = stores.filter(
        (s) =>
          s.issue === selectedService?.key &&
          (s.color === "red" || s.color === "#FFC107" || s.color === "amber")
      );

      amber = stores.filter(
        (s) =>
          s.issue === selectedService?.key &&
          (s.color === "#FFC107" || s.color === "amber")
      );

      healthy = stores.filter((s) => s.color === "green");
    } else {
      unhealthy = stores.filter(
        (s) => s.color === "red" || s.color === "#FFC107"
      );
      amber = stores.filter(
        (s) => s.color === "#FFC107" || s.color === "amber"
      );
      healthy = stores.filter((s) => s.color === "green");
    }

    setCounts({
      all: unhealthy.length + healthy.length,
      healthy: healthy.length,
      unhealthy: unhealthy.length,
      amber: amber.length,
    });
  }, [stores, source, selectedService]);

  /* ======================================================
     SORTING
  ======================================================= */
  const sortedStores = useMemo(
    () => (Array.isArray(stores) ? stores.slice().sort(compareStoreId) : []),
    [stores]
  );

  /* ======================================================
     FILTERING
  ======================================================= */
  const filteredStores = useMemo(() => {
    const base = sortedStores;

    return base.filter((store) => {
      if (source === "services" && selectedService) {
        if (filter === "Unhealthy") {
          return (
            store.issue === selectedService?.key &&
            (store.color === "red" || store.color === "#FFC107")
          );
        }
        if (filter === "Amber") {
          return (
            store.issue === selectedService?.key &&
            store.color === "#FFC107"
          );
        }
        if (filter === "Healthy") {
          return store.color === "green";
        }
      } else {
        if (Array.isArray(selectedStore) && selectedStore.length > 0) {
          const selectedIds = new Set(selectedStore.map((s) => s.value));
          return selectedIds.has(store.id);
        }
        if (filter === "Healthy") return store.color === "green";
        if (filter === "Unhealthy")
          return store.color === "red" || store.color === "#FFC107";
        if (filter === "Amber") return store.color === "#FFC107";
      }
      return true;
    });
  }, [sortedStores, selectedStore, filter, source, selectedService]);

  /* ======================================================
     PAGINATION
  ======================================================= */
  useEffect(() => {
    const totalPagesNow = Math.max(
      1,
      Math.ceil(filteredStores.length / pageSize)
    );
    if (currentPage > totalPagesNow) {
      setCurrentPage(totalPagesNow);
    }
  }, [filteredStores.length, pageSize, currentPage, setCurrentPage]);

  const indexOfLastItem = currentPage * pageSize;
  const indexOfFirstItem = Math.max(0, indexOfLastItem - pageSize);
  const currentStores = filteredStores.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.max(
    1,
    Math.ceil(filteredStores.length / pageSize)
  );

  /* ======================================================
     STORE DROPDOWN OPTIONS
  ======================================================= */
  const storeOptions = useMemo(
    () =>
      sortedStores.map((s) => ({
        value: s.id,
        label: String(s.id ?? ""),
      })),
    [sortedStores]
  );

  const visibleStart =
    filteredStores.length === 0 ? 0 : indexOfFirstItem + 1;
  const visibleEnd = Math.min(indexOfLastItem, filteredStores.length);

  /* ======================================================
     RETURN API
  ======================================================= */
  return {
    loading,
    error,
    selectedStore,
    setSelectedStore,
    pageSize,
    setPageSize,
    counts,
    storeOptions,
    filteredStores,
    currentStores,
    totalPages,
    visibleStart,
    visibleEnd,
  };
};

export default useStoreStatusLogic;